import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import { Button, Checkbox, Message, Modal } from "semantic-ui-react";
import { ErrorWrap } from "../../../helpers/error";
import { t } from "../../../constant/translations";

export const PublishModal = ({
  report,
  onConfirm,
  loading,
  error,
  trigger_props,
  reportDate,
  blockName,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [sendEmail, setSendEmail] = useState(false);
  const [errorState, setErrorState] = useState(new ErrorWrap(null));
  const prevLoadingRef = React.useRef(loading);

  useEffect(() => {
    const wasLoading = prevLoadingRef.current;
    prevLoadingRef.current = loading;

    if (wasLoading && !loading) {
      if (error && error.exists()) {
        setErrorState(error);
      } else {
        setIsOpen(false);
      }
    }
  }, [loading, error]);

  const handleClose = () => {
    setIsOpen(false);
    setSendEmail(false);
  };

  const handleOpen = () => {
    setIsOpen(true);
    setErrorState(new ErrorWrap(null));
    setSendEmail(false);
  };

  const handleConfirm = () => {
    onConfirm(sendEmail);
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      closeOnDimmerClick={!loading}
      trigger={<Button {...trigger_props} onClick={handleOpen} />}
    >
      <Modal.Header>
        {blockName} - {t("billing.publish_modal_header")} {reportDate}
      </Modal.Header>
      <Modal.Content>
        <p>{t("billing.publish_modal_content")}</p>
        <Checkbox
          label={t("billing.publish_modal_send_email")}
          checked={sendEmail}
          onChange={(e, { checked }) => setSendEmail(checked)}
          style={{ marginTop: "15px" }}
        />
        {errorState.exists() && (
          <Message error content={errorState.getGlobal()} />
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button
          icon="remove"
          onClick={handleClose}
          content={t("common.back")}
          disabled={loading}
        />
        <Button
          icon="checkmark"
          onClick={handleConfirm}
          content={t("labels.yes")}
          loading={loading}
        />
      </Modal.Actions>
    </Modal>
  );
};

PublishModal.propTypes = {
  report: PropTypes.object.isRequired,
  onConfirm: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.instanceOf(ErrorWrap),
  trigger_props: PropTypes.object.isRequired,
  reportDate: PropTypes.string.isRequired,
  blockName: PropTypes.string.isRequired,
};
